import { YEAR } from '@/common/constants';
import { BackIcon } from '@/common/icons/BackIcon';
import SelectControl from '@/components/controls/select-control';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import useStore from '@/lib/store';
import { FC, useEffect, useMemo, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const HeaderMonitoring: FC = () => {
  const form = useForm();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isInitialized, setIsInitialized] = useState(false);

  const { t } = useTranslation();
  const { plants } = useStore();
  const plantId = useWatch({ control: form.control, name: 'plant_id' });
  const yearId = useWatch({ control: form.control, name: 'year' });

  const options = useMemo(() => {
    return plants?.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [plants]);

  const plant = searchParams.get('plant_id');
  const year = searchParams.get('year');

  const currentYear = new Date().getFullYear().toString();

  useEffect(() => {
    if (!isInitialized) {
      const newParams = new URLSearchParams(searchParams);

      if (!plant) {
        newParams.set('plant_id', '2');
      }
      if (!year) {
        newParams.set('year', currentYear);
      }

      setSearchParams(newParams, { replace: true });
      setIsInitialized(true);
    }
  }, [isInitialized, plant, year, currentYear, searchParams, setSearchParams]);

  useEffect(() => {
    if (isInitialized) {
      if (plant) {
        form.setValue('plant_id', plant);
      }
      if (year) {
        form.setValue('year', year);
      }
    }
  }, [plant, year, isInitialized, form]);

  useEffect(() => {
    if (isInitialized && (plantId || yearId)) {
      const newParams = new URLSearchParams(searchParams);

      if (plantId) {
        newParams.set('plant_id', plantId);
      }
      if (yearId) {
        newParams.set('year', yearId);
      }

      setSearchParams(newParams, { replace: true });
    }
  }, [plantId, yearId, isInitialized, searchParams, setSearchParams]);

  return (
    <Form {...form}>
      <div className="py-2.5 px-10 flex justify-between items-center border-b border-gray-smoke">
        <div className="flex items-center gap-5">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="!py-0 px-2 h-[32px]"
          >
            <BackIcon />
          </Button>
          <p className="text-lg leading-7 text-midnight-default font-medium">
            {t('monitoring')}
          </p>
        </div>
        <div className="flex gap-2">
          <SelectControl
            label={t('plant.type')}
            className="w-[200px] flex gap-2 items-center"
            control={form?.control}
            labelClass="text-nowrap"
            name="plant_id"
            options={options}
            notRequired
          />
          <SelectControl
            className="w-full"
            control={form?.control}
            name="year"
            options={YEAR}
            placeholder={t('year')}
            notRequired
          />
        </div>
        <span></span>
      </div>
    </Form>
  );
};
